module.exports = __webpack_public_path__ + "static/media/lewy-gora-geo.5069cadb.svg";